import React, { useContext, useState, useEffect, useRef } from 'react';
import { store } from './Freight';
import { DataGrid } from '@material-ui/data-grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { localText } from '../../../../../../langs/fa/data-grid';
import moment from 'moment-jalaali';
import { __ } from '../../../../../../utils/i18n';
import { useHistory, useParams } from 'react-router-dom';
import NoOrders from './NoOrders';
import Accordion from '../../../../../../components/Accordion/Accordion';
import FleetsTextFields from '../../../../../../components/TextFields/FleetsTextFields';
import SelectCities from '../../../../../../components/FormInputs/SelectCities';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const OrdersList = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { state, dispatch } = useContext(store);
  const { fetchingOrders } = state;
  const { orders } = state;
  const [fleetOptions, setFleetOptions] = useState([]);
  const [destination, setDestination] = useState(null);
  const firstRun = useRef(true);
  const columns = [
    { field: 'loadDate', headerName: 'بارگیری', width: 130 },
    { field: 'origin', headerName: 'مبدا', width: 100 },
    { field: 'fleetOptions', headerName: 'ناوگان', flex: 1 },
    { field: 'fleetCount', headerName: 'تعداد', width: 100 },
    { field: 'destination', headerName: 'مقصد', width: 100 },
    { field: 'loadType', headerName: 'محموله', width: 120 },
    { field: 'orderStatus', headerName: 'وضعیت', width: 120 },
  ];
  const history = useHistory();

  const fetchOrders = async ({ page }) => {
    setLoading(true);
    const res = await fetchingOrders(
      id,
      page,
      orders.limit,
      fleetOptions,
      destination
    );
    setLoading(false);
    dispatch({ type: 'LOAD', payload: { name: 'orders', value: res } });
  };

  const handlePageChange = async ({ page }) => {
    if (orders.page === page) return;
    fetchOrders({ page });
  };

  const handleChangeFleetOptions = (selection) => {
    setFleetOptions(selection);
  };

  const handleChangeDestination = (city) => {
    setDestination(city);
  };

  const handleSelectOrder = (order) => {
    history.push(`/protected/admin/freights/editFreightOrder/${order.row.id}`);
  };

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    fetchOrders({ page: orders?.page });
  }, [fleetOptions, destination]);

  return (
    <>
      <h4>سفارشات:</h4>
      <Accordion title="فیلترهای سفارش">
        <div className={classes.filters}>
          <FleetsTextFields
            selection={fleetOptions}
            onChange={handleChangeFleetOptions}
            single
          />
          <SelectCities
            isMulti={false}
            placeholder="مقصد"
            city={destination}
            onSelect={handleChangeDestination}
            hasLabel
          />
        </div>
      </Accordion>
      <div style={{ height: 300, width: '100%', marginTop: 10 }}>
        {orders ? (
          <DataGrid
            rows={
              orders && orders.docs
                ? orders.docs.map((o) => ({
                    id: o._id,
                    loadDate: moment(o.createdAt).format('jYYYY/jMM/jDD'),
                    origin: o.origin.city.title,
                    fleetOptions: o.fleetOptions
                      .map((fl) => {
                        return `${fl.fleet.title}(${fl.title})`;
                      })
                      .join('، '),
                    fleetCount: o.fleetCount,
                    destination: o.destination.city.title,
                    loadTime: moment(o.createdAt).format('jYYYY/jMM/jDD HH:mm'),
                    loadType: o?.cargoType?.title,
                    packaging: 'ندارد',
                    orderStatus: __(o.status),
                  }))
                : []
            }
            columns={columns}
            localeText={localText}
            pageSize={orders && orders.limit ? orders.limit : 0}
            rowCount={orders && orders.totalDocs ? orders.totalDocs : 0}
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={loading}
            disableMultipleSelection
            density="compact"
            components={{
              noRowsOverlay: NoOrders,
            }}
            onCellClick={handleSelectOrder}
          />
        ) : (
          <Skeleton height={300} variant="rect" animation="wave" />
        )}
      </div>
    </>
  );
};

export default React.memo(OrdersList);
